import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

const IntegerNumberInput = (
  { onChange, onBlur, value, name, error, label, helperText, ...props },
  ref,
) => (
  <FormControl isInvalid={!!error}>
    {!!label && (
      <FormLabel fontSize="lg" fontWeight="bold" htmlFor={name}>
        <FormattedMessage {...label} />
      </FormLabel>
    )}
    <NumberInput
      {...props}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      name={name}
      ref={ref}
      isValidCharacter={char => /[0-9+-]/.test(char)}
      isInvalid={!!error}
      size={['md', 'lg']}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
    {error ? (
      <FormErrorMessage>{error.message}</FormErrorMessage>
    ) : (
      !!helperText && (
        <FormHelperText>
          <FormattedMessage {...helperText} />
        </FormHelperText>
      )
    )}
  </FormControl>
);

const ForwardWithRef = forwardRef(IntegerNumberInput);

export { ForwardWithRef as IntegerNumberInput };
